import React from "react";
import ReactDOM from "react-dom";

import EmbedBlockerContainer from "components/content-blocks/embed/EmbedBlockerContainer";
import Embed from "components/content-blocks/embed/Embed";

(() => {
  const embeds = document.querySelectorAll("[data-html-embed]");

  [...embeds].forEach((embed) => {
    const embedCode = decodeURIComponent(embed.dataset.htmlEmbed);

    ReactDOM.render(
      <EmbedBlockerContainer>
        <Embed embed={embedCode} />
      </EmbedBlockerContainer>,
      embed
    );
  });
})();
